import type { ReactNode } from "react";

import bfcLogo from "/bfc-main.svg";

import { AccountMenu } from "./account-menu";

import styles from "./app-header.module.css";

interface AppHeaderProps {
  /** Tool navigation, rendered left of the logo. */
  nav?: ReactNode;
  /** Tool-scoped controls, rendered left of the account menu. The warehouse
   *  picker goes here. */
  actions?: ReactNode;
}

/**
 * The shell header, shown on every screen under an organisation.
 *
 * It carries the brand and the account menu, which every screen has. Navigation
 * and the warehouse picker are passed in by the tool that needs them, because
 * neither is global.
 */
export function AppHeader({ nav, actions }: AppHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        {nav}
        <div className={styles.logoBlock}>
          <img src={bfcLogo} alt="BFC logo" />
          <div className={styles.betaBanner}>{"Beta"}</div>
        </div>
      </div>
      <div className={styles.headerRight}>
        {actions}
        {/* Shell-level, not tool-level: signing out and getting back to the
            product picker must not require being inside a tool. */}
        <AccountMenu />
      </div>
    </header>
  );
}
